module.exports = __webpack_public_path__ + "img/zhuanpan.a82c474f.png";